import { SortOrder } from 'components/molecule/table/RenderTable';
import { SortParam } from 'constants/params/paramKeys';
import { addFilterField } from 'utils/helper/helper';

export const getDefaultTimeColumn = (paramsObject, fallback) => (paramsObject && paramsObject.timeColumn) || fallback;

export function buildSortParamsForUpdate(nextSort, timeColumnVal) {
  if (nextSort.order === SortOrder.NONE) {
    if (nextSort.column === timeColumnVal) {
      return {
        [SortParam.COLUMN]: timeColumnVal,
        [SortParam.ORDER]: SortOrder.ASC,
      };
    }
    return {
      [SortParam.COLUMN]: timeColumnVal,
      [SortParam.ORDER]: SortOrder.DESC,
    };
  }
  return {
    [SortParam.COLUMN]: nextSort.column,
    [SortParam.ORDER]: nextSort.order,
  };
}

export function buildSortClause(sort, timeColumnVal) {
  return sort.order === SortOrder.NONE ? `${timeColumnVal} ${SortOrder.DESC}` : `${sort.column} ${sort.order}`;
}

export function withSortInFilters(filters, sortClause) {
  return {
    ...filters,
    ...addFilterField('filter[s]', sortClause, true),
  };
}
